import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Badge } from '@/components/ui/badge';
import { Settings, Zap, Check, Loader2 } from 'lucide-react';

export function SettingsTab({ settings, settingsChanged, setSettings, setSettingsChanged, saveSettings }) {
  if (!settings) return <Loader2 className="w-5 h-5 animate-spin text-neutral-400 mx-auto" />;

  const updateSetting = (key, value) => {
    setSettings(s => ({ ...s, [key]: value }));
    setSettingsChanged(true);
  };

  const updateBoostPkg = (pkgId, field, value) => {
    setSettings(s => ({
      ...s,
      boost_packages: { ...s.boost_packages, [pkgId]: { ...s.boost_packages[pkgId], [field]: value } }
    }));
    setSettingsChanged(true);
  };

  return (
    <div className="max-w-3xl space-y-6">
      <div className="bg-white dark:bg-neutral-800 rounded-xl border dark:border-neutral-700 p-6 space-y-5">
        <h3 className="font-semibold text-neutral-900 dark:text-white flex items-center gap-2"><Settings className="w-4 h-4" /> Limites annonces</h3>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label className="text-xs text-neutral-500">Entreprise non verifiee (max annonces)</Label>
            <Input type="number" value={settings.max_listings_unverified || 2} onChange={(e) => updateSetting('max_listings_unverified', parseInt(e.target.value) || 0)} data-testid="setting-max-unverified" />
          </div>
          <div>
            <Label className="text-xs text-neutral-500">Entreprise verifiee (max annonces)</Label>
            <Input type="number" value={settings.max_listings_verified || 50} onChange={(e) => updateSetting('max_listings_verified', parseInt(e.target.value) || 0)} data-testid="setting-max-verified" />
          </div>
        </div>
      </div>
      <div className="bg-white dark:bg-neutral-800 rounded-xl border dark:border-neutral-700 p-6 space-y-5">
        <div className="flex items-center justify-between">
          <h3 className="font-semibold text-neutral-900 dark:text-white flex items-center gap-2"><Zap className="w-4 h-4 text-[#F25C05]" /> Offres de boost</h3>
          <p className="text-xs text-neutral-400">Lie a Stripe — Les prix modifies seront utilises lors du prochain achat</p>
        </div>
        {settings.boost_packages && Object.entries(settings.boost_packages).map(([pkgId, pkg]) => (
          <div key={pkgId} className={`rounded-xl border-2 p-5 ${pkg.type === 'homepage' ? 'border-[#F25C05] bg-orange-50/30 dark:bg-orange-900/10' : pkg.type === 'search_top' ? 'border-[#1F3F72] bg-blue-50/30 dark:bg-blue-900/10' : 'border-amber-400 bg-amber-50/30 dark:bg-amber-900/10'}`} data-testid={`boost-pkg-${pkgId}`}>
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${pkg.type === 'homepage' ? 'bg-[#F25C05]/10 text-[#F25C05]' : pkg.type === 'search_top' ? 'bg-[#1F3F72]/10 text-[#1F3F72]' : 'bg-amber-500/10 text-amber-600'}`}>
                  <Zap className="w-5 h-5" />
                </div>
                <div>
                  <Input value={pkg.name || ''} onChange={(e) => updateBoostPkg(pkgId, 'name', e.target.value)} className="font-bold text-base border-0 bg-transparent p-0 h-auto shadow-none focus-visible:ring-0" data-testid={`boost-name-${pkgId}`} />
                  <Input value={pkg.description || ''} onChange={(e) => updateBoostPkg(pkgId, 'description', e.target.value)} className="text-xs text-neutral-500 border-0 bg-transparent p-0 h-auto shadow-none focus-visible:ring-0 mt-0.5" data-testid={`boost-desc-${pkgId}`} />
                </div>
              </div>
              <Badge className={`${pkg.type === 'homepage' ? 'bg-orange-100 text-orange-700' : pkg.type === 'search_top' ? 'bg-blue-100 text-blue-700' : 'bg-amber-100 text-amber-700'}`}>{pkg.type}</Badge>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label className="text-xs text-neutral-500 mb-1 block">Prix (€)</Label>
                <div className="relative">
                  <Input type="number" step="0.01" value={pkg.price || 0} onChange={(e) => updateBoostPkg(pkgId, 'price', parseFloat(e.target.value) || 0)} className="pr-8" data-testid={`boost-price-${pkgId}`} />
                  <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-neutral-400">€</span>
                </div>
              </div>
              <div>
                <Label className="text-xs text-neutral-500 mb-1 block">Duree (jours)</Label>
                <Input type="number" value={pkg.days || pkg.duration_days || 7} onChange={(e) => updateBoostPkg(pkgId, 'days', parseInt(e.target.value) || 1)} data-testid={`boost-duration-${pkgId}`} />
              </div>
            </div>
          </div>
        ))}
      </div>
      {settingsChanged && (
        <Button className="bg-[#1F3F72] hover:bg-[#1a3561] text-white" onClick={saveSettings} data-testid="save-settings"><Check className="w-4 h-4 mr-1" /> Sauvegarder les parametres</Button>
      )}
    </div>
  );
}
